import React from "react";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { LegalDocument } from "./LegalDocument";
import { parseLegalDoc } from "./legalMarkdown";
import { termosPrivacidade } from "./content/termosPrivacidade";

export const PrivacyPage: React.FC = () => {
  const doc = React.useMemo(() => parseLegalDoc(termosPrivacidade), []);
  return (
    <LegalDocument
      doc={doc}
      shortTitle="Privacidade"
      icon={<ShieldOutlinedIcon />}
      testId="privacy-page"
    />
  );
};

export default PrivacyPage;
